import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import QuizList from './components/QuizList';
import QuizContainer from './components/QuizContainer';
import WordList from './components/WordList';
import ReviewMode from './components/ReviewMode';
import Achievements from './components/Achievements';
import AppNavbar from './components/Navbar';
import './css/navbar.css';
import './css/modern-design.css';

function App() {
    return (
        <Router>
            <AppNavbar />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/quiz-list/:category" element={<QuizList />} />
                <Route path="/quiz-list/:partOfSpeech/:difficulty" element={<QuizList />} />
                <Route path="/quiz/:category/:range" element={<QuizContainer />} />
                <Route path="/quiz/:partOfSpeech/:difficulty/:range" element={<QuizContainer />} />
                <Route path="/wordlist" element={<WordList />} />
                <Route path="/review" element={<ReviewMode />} />
                <Route path="/achievements" element={<Achievements />} />
            </Routes>
        </Router>
    );
}

export default App;
